import { lazy } from "react";
import { Route, Routes } from "react-router-dom";

const ReferralLayout = lazy(() =>
  import(
    /* webpackChunkName: "ReferralLayout" */ /* webpackPrefetch: true */ "./layout"
  ).then((module) => ({ default: module.ReferralLayout })),
);

const NewReferral = lazy(() =>
  import(
    /* webpackChunkName: "NewReferrals" */ /* webpackPrefetch: true */ "./new/page"
  ).then((module) => ({ default: module.Page })),
);

export const ReferralRoutes = () => (
  <Routes>
    <Route path="new" element={<ReferralLayout />}>
      <Route index element={<NewReferral />} />
    </Route>
  </Routes>
);
